/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free WCAG colour contrast checker. Enter a text and background colour to see the contrast ratio and whether it passes AA and AAA for normal and large text.`)
};

const es_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de casos online gratuito. Convierte al instante texto a mayúsculas, minúsculas, título en mayúsculas, oración en mayúsculas, camelCase, PascalCase, snake_case, kebab-case y más.`)
};

const de_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Case-Converter. Konvertiere Text sofort in UPPERCASE, lowercase, Title Case, Sentence case, camelCase, PascalCase, snake_case, kebab-case und mehr.`)
};

const nl_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online zaakconverter. Zet tekst onmiddellijk om naar hoofdletters, kleine letters, titeltekst, zintekst, camelCase, PascalCase, snake_case, kebab-case en meer.`)
};

const fr_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de casse gratuit en ligne. Transformez instantanément le texte en majuscules, minuscules, casse titre, casse phrase, camelCase, PascalCase, snake_case, kebab-case et bien d'autres.`)
};

const it_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di case gratuito online. Converti istantaneamente il testo in maiuscoli, minuscoli, titolo, frase, camelCase, PascalCase, snake_case, kebab-case e altro.`)
};

const pt_br2_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de caso online gratuito. Converta instantaneamente o texto para maiúsculas, minúsculas, título, frase, camelCase, PascalCase, snake_case, kebab-case e mais.`)
};

const pt_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de casos online gratuito. Converta instantaneamente o texto para maiúsculas, minúsculas, caso de título, caso de sentença, camelCase, PascalCase, snake_case, kebab-case e muito mais.`)
};

const ja_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインケースコンバーター。テキストをuppercase、lowercase、title case、sentence case、camelCase、PascalCase、snake_case、kebab-caseなどに瞬時に変換できます。`)
};

const zh_cc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线大小写转换器。立即将文本转换为全大写、全小写、标题格式、句首大写、camelCase、PascalCase、snake_case、kebab-case 等格式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_meta_description", locale)
	if (locale === "en") return en_cc_meta_description(inputs)
	if (locale === "es") return es_cc_meta_description(inputs)
	if (locale === "de") return de_cc_meta_description(inputs)
	if (locale === "nl") return nl_cc_meta_description(inputs)
	if (locale === "fr") return fr_cc_meta_description(inputs)
	if (locale === "it") return it_cc_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_cc_meta_description(inputs)
	if (locale === "pt") return pt_cc_meta_description(inputs)
	if (locale === "ja") return ja_cc_meta_description(inputs)
	return zh_cc_meta_description(inputs)
};